import {
  AfterContentInit,
  Component,
  DoCheck,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'lp2-blob-progress-bar',
  templateUrl: './blob-progress-bar.component.html',
  styleUrls: ['./blob-progress-bar.component.scss'],
})
export class BlobProgressBarComponent
  implements OnChanges, AfterContentInit, DoCheck {
  @Input() percentageComplete = 0;
  @Input() labelText = '';
  @Input() isLabelBold = false;
  @Input() isAchieved = false;
  @Input() isFirst = false;
  @Input() isLast = false;
  @Input() isDetailBubbleVisible = false;
  @Input() levelNum = 1;
  @Input() gamificationEnabled = false;
  @ViewChild('positionBubbleWrapper') positionBubbleWrapper: ElementRef;
  @ViewChild('meter') meter: ElementRef;
  @ViewChild('progressLevelContainer') progressLevelContainer: ElementRef;

  detailBubblePositionY = 0;
  detailBubblePositionX = 0;

  originalContainerWidth = 0;
  animationDelay = 0.3;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      !isNaN(changes.percentageComplete.currentValue) &&
      this.meter &&
      this.positionBubbleWrapper &&
      this.isDetailBubbleVisible
    ) {
      this.positionDetailBubble();
    }

    this.detailBubblePositionY = this.gamificationEnabled ? -8 : 0;
  }

  ngAfterContentInit() {
    if (
      !isNaN(this.percentageComplete) &&
      this.isDetailBubbleVisible &&
      this.progressLevelContainer
    ) {
      this.originalContainerWidth = this.progressLevelContainer.nativeElement.offsetWidth;
    }
    this.animationDelay = 0.8 + 0.2 * this.levelNum;
  }

  ngDoCheck() {
    const newContainerWidth = this.progressLevelContainer.nativeElement
      .offsetWidth;
    if (
      this.isDetailBubbleVisible &&
      newContainerWidth !== this.originalContainerWidth
    ) {
      this.originalContainerWidth = newContainerWidth;
      this.positionDetailBubble();
    }
  }

  positionDetailBubble() {
    this.detailBubblePositionX =
      -32 +
      (this.meter.nativeElement.offsetWidth / 100) * this.percentageComplete +
      (this.gamificationEnabled && document.documentElement.clientWidth <= 710
        ? 0
        : this.originalContainerWidth * 0.05);
  }

  onResize() {
    if (!this.isDetailBubbleVisible) {
      return;
    }
    this.positionDetailBubble();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/blob-progress-bar/blob-progress-bar.component.ts